import script from "./UsuariosAdministrar.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuariosAdministrar.vue?vue&type=script&setup=true&lang=js"

import "./UsuariosAdministrar.vue?vue&type=style&index=0&id=3e3e8c82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e3e8c82"]])

export default __exports__